import {Component, OnDestroy, OnInit} from '@angular/core';

import {
    DatabaseService,
    IconService, MenuService,
    ParametersService,
    SettingsAccountService,
    SubtitlesService,
    TilesService
} from "../../core";
import {Subscription} from "rxjs";
import {TilesData} from "../../models";

@Component({
    selector: 'tiles',
    templateUrl: './tiles.component.html',
    styleUrls: ['./tiles.component.scss']
})
export class TilesComponent implements OnInit, OnDestroy {
    private tilesSubscription: Subscription;

    constructor(
        private database: DatabaseService,
        private icon: IconService,
        public menu: MenuService,
        public parameters: ParametersService,
        public settingsAccount: SettingsAccountService,
        private subtitles: SubtitlesService,
        public tiles: TilesService,
    ) {
    }

    ngOnInit() {
        if (Array.isArray(this.menu.allElementMenu) && this.menu.allElementMenu.length) {
            const tiles = this.database.tiles.getValue();
            this.setTiles(tiles);
        }
        this.tilesSubscription = this.database.tiles$.subscribe(tiles => {
            this.setTiles(tiles);
        })
    }

    ngOnDestroy() {
        this.tilesSubscription.unsubscribe();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setIcon(val: number) {
        return this.icon.setIcon(val);
    }

    isOpenContainer() {
        return this.tiles.createContainer
            && this.tiles.withoutContainer.elements.length
            && this.tiles.withoutContainer.elements.some(tile => tile.visibility);
    }

    private setTiles(tiles: {} | TilesData[]): void {
        if (Array.isArray(tiles)) {
            this.tiles.getTiles(tiles);
        } else {
            this.tiles.clearTiles();
        }
    }
}
